import { render, staticRenderFns } from "./FuelOil.vue?vue&type=template&id=13e25c66&scoped=true&"
import script from "./FuelOil.vue?vue&type=script&lang=js&"
export * from "./FuelOil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e25c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e25c66')) {
      api.createRecord('13e25c66', component.options)
    } else {
      api.reload('13e25c66', component.options)
    }
    module.hot.accept("./FuelOil.vue?vue&type=template&id=13e25c66&scoped=true&", function () {
      api.rerender('13e25c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/FuelOil.vue"
export default component.exports